<template>
	<div id="Perfil">
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="20">
				<a-row v-if="idPerfilPortal!=4">
					<span>Usuário:</span>
				</a-row>				
				<a-row v-if="idPerfilPortal!=4">					
					<a-select
						show-search
						option-filter-prop="children"
						style="width: 40%"
						@change="handleChangeUsuario"
						:value="valueUsuario"
						:disabled="loading"
						:allowClear="valueUsuario!=0"
						>
						<a-select-option v-for="usuario in usuarios" :key="usuario.idUsuario">
							{{usuario.nome}}
						</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="4" style="text-align: right;">
				<a-button
					type="primary"						
					class="tr-search-btn"
					style="width: 130px;"
					@click.stop.prevent="onNewPerfil"
					:disabled="loading"
					v-if="habilitarFuncionalidade('PermitirIncluir')"
				>Novo Perfil</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table
				:columns="columns"
				:rowKey="record => record.idPerfilTribunal"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="pagination"
				@change="handleTableChange"
				size="middle"
			>
				<template slot="descricaoStatusMonitoramento" slot-scope="descricaoStatusMonitoramento, record">
					<div v-if="(record.statusMonitoramento==0 && idUsuarioPortal==record.idUsuario)">
						<a-tooltip>
							<template slot="title">Cadastrar Fontes</template>
							<a @click="cadastrarFontes(record)">{{record.descricaoStatusMonitoramento}}</a>							
						</a-tooltip>
					</div>
					<div v-else>
						{{record.descricaoStatusMonitoramento}}
					</div>
				</template>				
				<template v-if="(idUsuarioPortal==record.idUsuario || ((idPerfilPortal == 6 || idPerfilPortal == 1) && habilitarFuncionalidade('PermitirAlterar'))) && ([0,4,5,12,13,99].includes(record.statusMonitoramento))"
					slot="editar" slot-scope="editar, record">
					<div>
						<a-tooltip>
							<template slot="title">Editar Perfil</template>
							<a-icon 
								type="form" 
								class="cursor"
								@click="editarPerfilTribunal(record)"/>
						</a-tooltip>
					</div>
				</template>
				<template slot="complemento" slot-scope="complemento, record">
					<div>						
						<a-popover title="Dados complementares" :overlayStyle="oStyle" placement="rightTop">
							<template slot="content">
								<a-table
									id="tabelaCompl"
									:columns="columnsCompl"
									:rowKey="record => record.$id"
									:dataSource="[record]"                                    
									size="middle"
									:pagination="false"
								>
									<template slot="dataCadastro" slot-scope="dataCadastro, record">
										{{formatarDataLocal(record.dataCadastro, true, 'DD/MM/YYYY HH:mm:ss')}}
									</template>
								</a-table>
							</template>
							<a-icon type="plus-circle" class="cursor" style="margin-left: 17px;"/>
						</a-popover>
					</div>
				</template>	
			</a-table>			
		</a-row>

		<modal-component
			class="modal-component"
			title="Editar Perfil"
			ref="modalPerfilTribunal"
			width="50%"
			:maskClosable="false"
		>
			<a-row v-if="idPerfilPortal==6">
				<a-col :span="24">					
					<span class="tr-label">Cliente:</span>
					<a-input
						:maxLenght=50
						:value="nomeCliente"
						:disabled="true"
						readOnly
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="24">
					<span class="tr-label">Usuário:</span>
					<a-input
					    :maxLenght=50
						:value="nomeUsuario"
						:disabled="true"
						readOnly
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-col>
			</a-row>
			<a-row>					
				<a-col :span="24">
					<span class="tr-label">Nome:</span>
					<a-input
					    :maxLenght=100
						placeholder="Insira o nome completo"
						v-model="perfilTribunal.nome"
						:allowClear="perfilTribunal.nome!=''"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="7">
					<span class="tr-label">Tipo Perfil:</span>						
					<a-select class="tr-ant-select" default-value="Advogado" v-model="perfilTribunal.perfil" @change="handlePerfilTribunalPerfil" :disabled="desabTipoPerfil" style="width: 100%">
						<a-select-option value="Advogado">Advogado</a-select-option>							
						<a-select-option value="Procurador">Procurador</a-select-option>
						<a-select-option value="Representante">Representante</a-select-option>
					</a-select>
				</a-col>
				<a-col :span="7" :offset="2">
					<span id="oabEdit" v-bind:class="classeAste">OAB: (Sem letras da UF)</span>
					<a-input
					  :maxLenght=10
						placeholder="Insira OAB"
						v-model="perfilTribunal.oab"							
						:allowClear="perfilTribunal.oab!=''"
					>
						<a-icon slot="prefix" type="solution"/>
					</a-input>
				</a-col>
				<a-col :span="6" :offset="2">
					<span id="ufOabEdit" v-bind:class="classeAste">UF OAB:</span>
					<a-select
						class="tr-ant-select"
						style="width: 100%"
						@change="handleChangeUf"
						:value="valueUF"
						:allowClear="(valueUF!=null && valueUF!=undefined)"
						>
						<a-select-option v-for="uf in ufs" :key="uf.key">
							{{uf.valor}}
						</a-select-option>
					</a-select>
				</a-col>					                   
			</a-row>
			<a-row v-if="false">
				<a-col :span="1">
					<span class="tr-label">Tipo Pessoa:</span>
					<a-select class="tr-ant-select" default-value="Fisica" v-model="perfilTribunal.tipoPessoa" style="width: 80%">
						<a-select-option value="Fisica">Fisica</a-select-option>
						<a-select-option value="Juridica">Juridica</a-select-option>
					</a-select>
				</a-col> 
			</a-row>
			<span slot="buttons">
				<a-row type="flex" align="middle">
					<a-col :span="12" style="text-align: left;">
						<a-switch style="margin-left: 15px;" defaultChecked v-model="perfilTribunal.status" @change="handlerSwitchChange">
							<a-icon type="check" slot="checkedChildren"/>
							<a-icon type="close" slot="unCheckedChildren"/>
						</a-switch>
						<span style="margin-left: 10px;">Situação</span>
						<a-tooltip>
							<template slot="title">Ao desativar o perfil, todas as fontes vinculadas a ele serão desativadas consequentemente</template>
							<a-icon type="info-circle" style="margin-left: 10px; color: #ff0130;"/>
						</a-tooltip>
					</a-col>
					<a-col :span="12">
						<a-row type="flex" justify="end" align="middle" :gutter="40">
							<a-col>
								<a-button key="back" class="perfilTribunal-form-button" @click.prevent="handleCancelEditPerfilTribunal()">Retornar</a-button>
							</a-col>
							<a-col>
								<a-button
									key="submit"
									class="perfilTribunal-form-button"
									type="primary"
									@click.prevent="handleOkEditPerfilTribunal()"
									v-if="habilitarFuncionalidade('PermitirAlterar')"
								>Salvar</a-button>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</span>
		</modal-component>

		<modal-component
			class="modal-component"				
			title="Novo Perfil"
			ref="modalnewPerfilTribunal"
			width="50%"
			:maskClosable="false"
		>
			<a-row v-if="idPerfilPortal==6">
				<a-col :span="24">
					<a-row>
						<span class="tr-label">Cliente:</span>
					</a-row>
					<a-row>
						<a-select
							class="tr-ant-select"
							style="width: 100%"
							@change="handleClienteChange"
							:disabled="loading"
							:value="valueCliente"
							:allowClear="(valueCliente!=null && valueCliente!=undefined)"
							>
							<a-select-option v-for="cli in clientes" :key="cli.idCliente">
								{{cli.nome}}
							</a-select-option>
						</a-select>
					</a-row>
				</a-col>
			</a-row>
			<a-row v-if="idPerfilPortal==6">
				<a-col :span="24">
					<a-row>
						<span class="tr-label">Usuário:</span>
					</a-row>				
					<a-row>
						<a-select
							class="tr-ant-select"
							style="width: 100%"
							@change="handleChangeUsuarioModal"
							:value="valueUsuarioModal"
							:disabled="loading"
							>
							<a-select-option v-for="usu in usuariosModal" :key="usu.idUsuario">
								{{usu.nome}}
							</a-select-option>
						</a-select>
					</a-row>
				</a-col>
			</a-row>
			<a-row v-if="idPerfilPortal!=6">
				<a-col :span="24">
					<span class="tr-label">Usuário:</span>
					<a-input 	
					    :maxLenght=50
						:value="nomeUsuario"
						:disabled="true"
						readOnly
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-col>
			</a-row>
			<a-row>					
				<a-col :span="24">
					<span class="tr-label">Nome:</span>
					<a-input
					    :maxLenght=100
						placeholder="Insira o nome completo"
						v-model="perfilTribunal.nome"
						:allowClear="perfilTribunal.nome!=''"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-col>
			</a-row>
			<a-row>
				<a-col :span="7">
					<span class="tr-label">Tipo Perfil:</span>						
					<a-select class="tr-ant-select" default-value="Advogado" v-model="perfilTribunal.perfil" @change="handlePerfilTribunalPerfil" :disabled="desabTipoPerfil" style="width: 100%">
						<a-select-option value="Advogado">Advogado</a-select-option>							
						<a-select-option value="Procurador">Procurador</a-select-option>
						<a-select-option value="Representante">Representante</a-select-option>
					</a-select>
				</a-col>
				<a-col :span="7" :offset="2">
					<span id="oab" v-bind:class="classeAste">OAB: (Sem letras da UF)</span>
					<a-input
					  :maxLenght=10
						placeholder="Insira OAB"
						v-model="perfilTribunal.oab"
						:allowClear="perfilTribunal.oab!=''"
				>
					<a-icon slot="prefix" type="solution"/>
				</a-input>
				</a-col>
				<a-col :span="6" :offset="2">
					<span id="ufOab" v-bind:class="classeAste">UF OAB:</span>						
					<a-select
						class="tr-ant-select"
						style="width: 100%"
						@change="handleChangeUf"
						:value="valueUF"
						:allowClear="(valueUF!=null && valueUF!=undefined)"
					>
						<a-select-option v-for="uf in ufs" :key="uf.key">
							{{uf.valor}}
						</a-select-option>
					</a-select>
				</a-col>
			</a-row>
			<a-row v-if="false">
				<a-col :span="1">
					<span class="tr-label">Tipo Pessoa:</span>
					<a-select class="tr-ant-select" default-value="Fisica" v-model="perfilTribunal.tipoPessoa" style="width: 80%">
						<a-select-option value="Fisica">Fisica</a-select-option>
						<a-select-option value="Juridica">Juridica</a-select-option>
					</a-select>
				</a-col> 
			</a-row>
			<span slot="buttons">
				<a-row type="flex" align="middle">
					<a-col :span="12" style="text-align: left;">														
					</a-col>
					<a-col :span="12">
						<a-row type="flex" justify="end" align="middle" :gutter="40">
							<a-col>
								<a-button key="back" class="perfilTribunal-form-button" @click.prevent="handleCancelNewPerfilTribunal()">Retornar</a-button>
							</a-col>
							<a-col>
								<a-button
									key="submit"
									class="perfilTribunal-form-button"
									type="primary"
									@click.prevent="handleOkNewPerfilTribunal()"
								>Salvar</a-button>
							</a-col>
						</a-row>
					</a-col>
				</a-row>					
			</span>
		</modal-component>
	</div>
</template>

<script>
import IntimacaoWebApi from "@/API/intimacaoWebApi";
import ModalComponent from "@/components/ModalComponent";
import { SET_VALUEPERFILTRIBUNAL } from "@/store/mutations";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";

const columns = [
	{
		title: "Tipo Perfil",
		dataIndex: "perfil",
		sorter: (a, b) => a.perfil.localeCompare(b.perfil),
		width: "10%",
		scopedSlots: { customRender: "perfil" }
	},
	{
		title: "Nome",
		dataIndex: "nome",
		sorter: (a, b) => a.nome.localeCompare(b.nome),
		//width: "25%",
		scopedSlots: { customRender: "nome" }
	},
    {
		title: "OAB",
		dataIndex: "oab",
		sorter: (a, b) => a.oab.localeCompare(b.oab),
		width: "10%",
		scopedSlots: { customRender: "oab" }
	},
    {
		title: "UF OAB",
		dataIndex: "ufOab",
		sorter: (a, b) => a.ufOab.localeCompare(b.ufOab),
		width: "10%",
		scopedSlots: { customRender: "ufOab" }
	},
	{
		title: "Status",
		dataIndex: "descricaoStatusMonitoramento",
		sorter: (a, b) => a.descricaoStatusMonitoramento.localeCompare(b.descricaoStatusMonitoramento),
		align: "center",
		width: "35%",
		scopedSlots: { customRender: "descricaoStatusMonitoramento" }
	},
	{
		title: "Complemento",
		width: "9%",
		align: "center",
		scopedSlots: { customRender: "complemento" }
	},
	{
		key: "IdPerfilTribunal",
		title: "Editar",
		dataIndex: "editar",
		align: "center",
		width: "7%",
		scopedSlots: { customRender: "editar" }
	}
];

const columnsCompl = [	
  {
		title: "Nome Usuário",
		dataIndex: "nomeUsuario",
		sorter: (a, b) => a.nomeUsuario.localeCompare(b.nomeUsuario),		
		scopedSlots: { customRender: "nomeUsuario" }
	},
	{
		title: "Nome Cliente",
		dataIndex: "nomeCliente",
		sorter: (a, b) => a.nomeCliente.localeCompare(b.nomeCliente),
		scopedSlots: { customRender: "nomeCliente" }
	}
];

export default {	
	name: "perfil",
	data() {
		return {
			idTela: 3,
			data: [],
			dataHist: [],
			strSearch: null,
			searchText: "",
			searchInput: null,
			pagination: {},
			loading: false,
            ufs:[],
			columns,
			columnsCompl,
			perfilTribunal: {
				idPerfilTribunal: 0,
				idUsuario: 0,
				perfil: "Advogado",
				nome: "",
				tipoPessoa: "Fisica",
				oab: "",
				ufOab: "",
                status: true,
				statusMonitoramento: 0,
				idUsuarioCadastro: 0,
				idUsuarioUltimaAlteracao: 0
			},
			valueUF: null,
			usuarios: [],
			valueUsuario: 0,
			idPerfilPortal: 0,
			idUsuarioPortal: 0,
			idClientePortal: null,
			classeAste: 'tr-label',
			nomeUsuario: '',
			oldAtivoStatus: true,
			desabTipoPerfil: false,
			clientes: [],
			valueCliente: null,			
			usuariosModal: [],
			valueUsuarioModal: null,
			nomeCliente: '',
			ehAlteracao: false
		};
	},
	mounted() {
		this.idUsuarioPortal = this.$store.state.auth.idUser;
		// this.nomeUsuario = this.$store.state.auth.nome;
		this.idPerfilPortal = this.$store.state.auth.idPerfilPortal;
		this.idClientePortal = this.$store.state.auth.idCliente;
		this.ufs = this.$store.state.global.ufs;
		if (this.idPerfilPortal == 6)
			this.recuperarClientes();
		this.carregarUsuarios();
		if (this.idPerfilPortal == 4)
			this.handleChangeUsuario(this.idUsuarioPortal);
		else
			this.handleChangeUsuario(undefined);
	},
	methods: {
		habilitarFuncionalidade(funcionalidade) {
			let retorno = Helpers.funcionalidadeAutorizada({
				idTela: this.idTela,
				funcionalidade: funcionalidade
			});
			return retorno;
		},
		carregarUsuarios(){
			this.loading = true;
			IntimacaoWebApi.getUsersExibicao({ idCliente: this.idClientePortal }).then(res => {
				this.loading = false;
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Cadastro de Perfil", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Cadastro de Perfil", res.data.result);
				} else {
					this.usuarios.push({ idUsuario: 0, nome: 'Todos' });
					this.usuarios.push.apply(this.usuarios, res.data.result.map(h => {
							return { idUsuario: h.idUsuario, nome: h.nome }
						}));
				}
			})
			.catch(res => {
				this.loading = false;
				showNotificationError(this, "Cadastro de Perfil", "Erro ao tentar carregar usuários.");
			});
		},
		handleChangeUsuario(value) {
			this.data = [];
			this.valueUsuario = value == undefined ? 0 : value;			
			this.fetch({ search: true, IdUsuario: this.valueUsuario, IdCliente: this.idClientePortal });
		},
		hasSpace(str) {
      return str.trim().includes(' ');
    },
		validarCampos(perfilTribunal){
			debugger

			let camposValidos = true;

			if (this.idPerfilPortal == 6 && this.ehAlteracao == false)
			{
				if (this.valueCliente == null || this.valueCliente == undefined){
					showNotificationError(this, "Cadastro de Perfil", "Cliente é campo obrigatório!");
					camposValidos = false;
				} else if (this.valueUsuarioModal == null || this.valueUsuarioModal == undefined){
					showNotificationError(this, "Cadastro de Perfil", "Usuário é um campo obrigatório!");
					camposValidos = false;
				}
			}

			if (camposValidos)
			{			
				if (perfilTribunal.nome == ""){
					showNotificationError(this, "Cadastro de Perfil", "Nome é um campo obrigatório!");
					camposValidos = false;
				} else if (!this.hasSpace(perfilTribunal.nome)){
					showNotificationError(this, "Cadastro de Perfil", "Informe o Nome completo!");
					camposValidos = false;
				} else if (perfilTribunal.tipoPessoa == ""){
					showNotificationError(this, "Cadastro de Perfil", "Tipo da pessoa é um campo obrigatório!");
					camposValidos = false;
				} else if ((perfilTribunal.perfil == "Advogado") && (perfilTribunal.oab == "" || perfilTribunal.oab == undefined)){
					showNotificationError(this, "Cadastro de Perfil", "OAB é um campo obrigatório!");
					camposValidos = false;
				} else if ((perfilTribunal.perfil == "Advogado") && (perfilTribunal.ufOab == "" || perfilTribunal.ufOab == undefined)){
					showNotificationError(this, "Cadastro de Perfil", "UF OAB é um campo obrigatório!");
					camposValidos = false;
				} else if ((perfilTribunal.perfil == "Advogado") && (!this.validarString(perfilTribunal.oab))){
					showNotificationError(this, "Cadastro de Perfil", "Digite na OAB somente números ou no máximo 1 letra!");
					camposValidos = false;
				}
			}

			return camposValidos;
		},
		validarString(input) {
			// Verifica se a string é composta apenas por números
			if (/^\d+$/.test(input)) {
					return true;
			}
			
			// Verifica se há exatamente uma letra e o restante são números
			if (/^[0-9]*[a-zA-Z]{1}[0-9]*$/.test(input)) {
					return true;
			}
			
			// Caso contrário, a string é inválida
			return false;
		},
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
      		pager.current = pagination.current;
      		this.pagination = pager;
		},
		fetch(params = {}) {
			this.loading = true;
			if (params.search) {
				IntimacaoWebApi.getPerfilTribunalExibicao(params).then(res => {
					this.loading = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Perfil", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Perfil", res.data.result);
					} else {						
						this.data = res.data.result;						
						this.pagination = { current: 1 };
					}
				});
			} else {
				this.loading = false;
			}
		},
		handlePerfilTribunalPerfil(value) {			
			this.perfilTribunal.perfil = value;			
			if (value != "Advogado")
			{
				this.classeAste = '';
			}
			else
			{
				this.classeAste = 'tr-label';
			}
		},
		onSearch(text) {			
			this.fetch({ search: true, Text: text, IdUsuario: this.idUsuarioPortal });
		},
		editarPerfilTribunal(perfilTribunal) {
			this.ehAlteracao = true;
			this.perfilTribunal.idPerfilTribunal = perfilTribunal.idPerfilTribunal;
			this.perfilTribunal.perfil = perfilTribunal.perfil;			
			this.perfilTribunal.nome = perfilTribunal.nome;
            this.perfilTribunal.tipoPessoa = perfilTribunal.tipoPessoa;
			this.perfilTribunal.oab = perfilTribunal.oab;			
			this.perfilTribunal.ufOab = perfilTribunal.ufOab;
			this.valueUF = perfilTribunal.ufOab;
            this.perfilTribunal.status = perfilTribunal.status;
			this.oldAtivoStatus = perfilTribunal.status;
            this.perfilTribunal.statusMonitoramento = perfilTribunal.statusMonitoramento;
			if (this.idPerfilPortal == 6 || this.idPerfilPortal == 1)
			{
				this.pegarClientePeloIdUsuario(perfilTribunal.idUsuario);
				this.pegarUsuarioId(perfilTribunal.idUsuario);				
			}
			this.handlePerfilTribunalPerfil(perfilTribunal.perfil);
			this.verificarExisteFonteAssociada(perfilTribunal);
			this.$refs.modalPerfilTribunal.showModal();			
		},
		pegarClientePeloIdUsuario(idUsuario)
		{
			IntimacaoWebApi.buscarClientePeloIdUsuario(idUsuario)
				.then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Perfil", res.data.errorMessage);						
						this.nomeCliente = '';
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Perfil", res.data.result);
						this.nomeCliente = '';
					} else {						
						this.nomeCliente = res.data.result.nome;
					}				
				})
				.catch(res => {					
					this.nomeCliente = '';
					//showNotificationError(this, "Cadastro de Perfil", "Erro ao tentar pegar cliente.");
				});
		},
		pegarUsuarioId(idUsuario)
		{
			IntimacaoWebApi.buscarUsuarioId(idUsuario)
				.then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Perfil", res.data.errorMessage);
						this.nomeUsuario = '';
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Perfil", res.data.result);
						this.nomeUsuario = '';
					} else {						
						this.nomeUsuario = res.data.result.nome;
					}				
				})
				.catch(res => {					
					this.nomeUsuario = '';
					//showNotificationError(this, "Cadastro de Perfil", "Erro ao tentar pegar usuario.");
				});
		},				
		onNewPerfil() {
			this.ehAlteracao = false;
			this.desabTipoPerfil = false;
			this.valueCliente = null;
			this.valueUsuarioModal = null;
			this.nomeUsuario = this.$store.state.auth.nome;
			this.handleCancelNewPerfilTribunal();
			this.handlePerfilTribunalPerfil(this.perfilTribunal.perfil);
			this.$refs.modalnewPerfilTribunal.showModal();
		},
		verificarExisteFonteAssociada(perfilTribunal) {			
			IntimacaoWebApi.recuperarContratoExibicao(perfilTribunal.idUsuario, perfilTribunal.idPerfilTribunal, (this.idClientePortal==null ? 0 : this.idClientePortal))
				.then(res => {
					this.loading = false;
					this.desabTipoPerfil = true;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Perfil", res.data.errorMessage);						
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Perfil", res.data.result);
					} else {					
						this.desabTipoPerfil = res.data.result.length > 0;
					}				
				})
				.catch(res => {
					this.loading = false;
					this.$root.loadingSpinner = false;
					this.desabTipoPerfil = true;
					showNotificationError(this, "Cadastro de Perfil", "Erro ao tentar carregar fontes.");
				});
		},
		handleOkEditPerfilTribunal(e) {
			if(!this.validarCampos(this.perfilTribunal)){
				return;
			}

			if ((this.oldAtivoStatus == true) && (this.perfilTribunal.status == false)) {
				const _this = this;
				const x = _this.$createElement;				
				this.$confirm({				
					title: x('div', {}, [
							x('p', "Ao desativar o perfil, todas as fontes vinculadas a ele serão desativadas consequentemente."),
						]),					
					content: h => <div style="font-size: 16px; color: #000000d9;">Deseja continuar?</div>,
					okText: 'Sim',        			
        			cancelText: 'Não',
					width: '25%',
					onOk() {
						_this.chamarAPIEditarPerfilTribunal();
					},
					onCancel() {},
				});
			} else {
				this.chamarAPIEditarPerfilTribunal();
			}			
		},
		chamarAPIEditarPerfilTribunal() {
			this.perfilTribunal.idUsuarioUltimaAlteracao = this.idUsuarioPortal;
			this.$root.loadingSpinner = true;
			IntimacaoWebApi.atualizarPerfilTribunal(this.perfilTribunal, this.idUsuarioPortal)
				.then(res => {
					this.$refs.modalPerfilTribunal.handleCancel();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Perfil", res.data.result);
						this.fetch({ search: true, IdUsuario: this.idUsuarioPortal });
					} else
						showNotificationError(this, "Cadastro de Perfil", res.data.errorMessage);
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Perfil", "Erro ao tentar editar perfil.");
				});
		},
		handleOkNewPerfilTribunal() {
			if(!this.validarCampos(this.perfilTribunal)){
				return;
			}
			if (this.idPerfilPortal == 6)
				this.perfilTribunal.idUsuario = this.valueUsuarioModal;
			else
				this.perfilTribunal.idUsuario = this.idUsuarioPortal;
			this.perfilTribunal.idUsuarioCadastro = this.idUsuarioPortal;
			this.perfilTribunal.idUsuarioUltimaAlteracao = this.idUsuarioPortal;
			this.perfilTribunal.status = true;
            this.perfilTribunal.statusMonitoramento = 0;
			this.$root.loadingSpinner = true;
			IntimacaoWebApi.inserirPerfilTribunal(this.perfilTribunal)
				.then(res => {
					this.$refs.modalnewPerfilTribunal.handleCancel();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Perfil", res.data.result);
						this.fetch({ search: true, IdUsuario: this.idUsuarioPortal });
					} else
						showNotificationError(this, "Cadastro de Perfil", res.data.errorMessage);
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Perfil", "Erro ao tentar inserir perfil.");
				});
		},
		handleCancelEditPerfilTribunal() {
			this.$refs.modalPerfilTribunal.handleCancel();
			this.perfilTribunal.idPerfilTribunal = 0;
			this.perfilTribunal.perfil = "Advogado";
			this.perfilTribunal.nome = "";
            this.perfilTribunal.tipoPessoa = "Fisica";
			this.perfilTribunal.oab = "";
			this.perfilTribunal.ufOab = "";
            this.perfilTribunal.status = true;
            this.perfilTribunal.statusMonitoramento = 0;
			this.perfilTribunal.idUsuarioCadastro = 0;
			this.perfilTribunal.idUsuarioUltimaAlteracao = 0;
			this.valueUF = null;
		},
		handleCancelNewPerfilTribunal() {
			this.$refs.modalnewPerfilTribunal.handleCancel();
			this.perfilTribunal.idPerfilTribunal = 0;
			this.perfilTribunal.perfil = "Advogado";
			this.perfilTribunal.nome = "";
            this.perfilTribunal.tipoPessoa = "Fisica";
			this.perfilTribunal.oab = "";
			this.perfilTribunal.ufOab = "";
            this.perfilTribunal.status = true;
            this.perfilTribunal.statusMonitoramento = 0;
			this.perfilTribunal.idUsuarioCadastro = 0;
			this.perfilTribunal.idUsuarioUltimaAlteracao = 0;
			this.valueUF = null;
		},
		handlerSwitchChange(value) {
			this.perfilTribunal.status = value;
		},
		cadastrarFontes(perfilTribunal) {
			this.$store.commit(SET_VALUEPERFILTRIBUNAL, perfilTribunal);
			this.$router.replace({ name: "fontes" });
		},
		handleChangeUf(value) {			
			this.valueUF = value;
			this.perfilTribunal.ufOab = this.valueUF;
		},
		recuperarClientes() {
			IntimacaoWebApi.getListarClientes().then(res => {
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Cadastro de Perfil", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Cadastro de Perfil", res.data.result);
				} else {
					this.clientes = res.data.result;
				}
			})
			.catch(res => {
				showNotificationError(this, "Cadastro de Perfil", "Erro ao tentar carregar clientes.");
			});
		},
		handleClienteChange(value) {			
			this.valueUsuarioModal = null;
			this.usuariosModal = [];
			this.valueCliente = value;			
			this.recuperarUsuario(this.valueCliente);
		},
		recuperarUsuario(idCliente) {
			if (idCliente != undefined && idCliente != null){
				IntimacaoWebApi.getUsuarioCliente(idCliente).then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Perfil", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Perfil", res.data.result);
					} else {
						this.usuariosModal = res.data.result;
					}
				});
			}
		},
		handleChangeUsuarioModal(value)
		{
			this.valueUsuarioModal = value;
		},
		formatarDataLocal(data, isDateTime, format) {
			return Helpers.formatarData(data, isDateTime, format);
		}
	},
	components: { ModalComponent }
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

.tr-ant-select {
	margin: 0px 0px 10px 0px;
}

.ant-switch {
	margin: 10px 0px 10px 0px;
}

.ant-input-affix-wrapper {
	margin: 0px 0px 10px 0px;
} 

.danger {
	color: red;
}

.sucess {
	color: green;
}

.default {
	color: black;
}

.custom-filter-dropdown {
	padding: 8px;
	border-radius: 4px;
	background: #fff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
	background-color: rgb(255, 192, 105);
	padding: 0px;
}

.cursor {
	cursor: pointer;
}

.cursor:hover {
  color: blue;
}
</style>

<style>
.perfilTribunal-form-button {
	width: 100px;
}
</style>